import React, { useMemo } from 'react';
import { apiHolder as api, apis } from 'api';
import BaseReadMail from '../ReadMail/ReadMail';
import useState2RM from '../../hooks/useState2ReduxMock';
import MailMultOperPanel from '../MailMultOperPanel/MailMultOperPanel';
import CustomerMailMultOperPanel from '../CustomerMail/ColumnCustomerMailList/CustomerMailMultOperPanel';
import SubordinateMailMultOperPanel from '../SubordinateMail/ColumnSubordinateMailList/SubordinateMailMultOperPanel';
import { LIST_MODEL } from '../../common/constant';
import { useAppSelector } from '@web-common/state/createStore';
import { isMainAccount, tpMailAttConfig } from '@web-mail/util';
import { tabId, tabType } from '@web-common/state/reducer/mailTabReducer';
import { useContactModel } from '@web-common/hooks/useContactModel';
import { transContactModel2ContactItem } from '@web-common/components/util/contact';
import './mailReadMail.scss';
import { useState2CustomerSlice, useState2SubordinateSlice } from '@web-mail/hooks/useState2SliceRedux';
import { getCustomerSliceIdByType } from '@web-mail/utils/slice';
const systemApi = api.api.getSystemApi();
const contactApi = api.api.requireLogicalApi(apis.contactApiImpl);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const MainReadMail = (props) => {
    var _a;
    const { id, from, openInNewWindow = false, tempContent, readOnly, getSignMailContent, requestUniqWrap, emptyRender, accountId } = props;
    const [mailEntities] = useState2RM('mailEntities');
    const currentMail = useMemo(() => (id ? mailEntities[id] : null), [mailEntities, id]);
    const [configMailLayout] = useState2RM('configMailLayout');
    const isUpDown = useMemo(() => configMailLayout === '3', [configMailLayout]);
    const propContact = (_a = currentMail === null || currentMail === void 0 ? void 0 : currentMail.sender) === null || _a === void 0 ? void 0 : _a.contact;
    const email = propContact ? contactApi.doGetModelDisplayEmail(propContact) : '';
    const currentTabType = useAppSelector(state => state.mailTabReducer.currentTab.type);
    const currentTabId = useAppSelector(state => state.mailTabReducer.currentTab.id);
    const selectedCustomerTab = useAppSelector(state => state.mailReducer.selectedCustomerTab);
    const isCustomerTab = process.env.BUILD_ISLINGXI ? false : useMemo(() => currentTabType === tabType.customer, [currentTabType]);
    const isSdTab = useMemo(() => currentTabType === tabType.subordinate, [currentTabType]);
    const sliceIdCm = useMemo(() => getCustomerSliceIdByType(selectedCustomerTab), [selectedCustomerTab]);
    const sliceIdSd = useMemo(() => {
        let id = currentTabId;
        if (currentTabType !== tabType.subordinate) {
            id = tabId.subordinate;
        }
        return id;
    }, [currentTabId, currentTabType]);
    const [listModel] = useState2RM('defaultMailListSelectedModel', 'doUpdateMailListSelectedModel');
    const [listModelCm] = useState2CustomerSlice('defaultMailListSelectedModel', undefined, sliceIdCm);
    const [listModelSd] = useState2SubordinateSlice('defaultMailListSelectedModel', undefined, sliceIdSd);
    const logicListModel = useMemo(() => {
        if (currentTabType == tabType.customer) {
            return listModelCm;
        }
        if (currentTabType == tabType.subordinate) {
            return listModelSd;
        }
        return listModel;
    }, [listModel, listModelCm, listModelSd, currentTabType]);
    const account = useMemo(() => { var _a; return (currentMail === null || currentMail === void 0 ? void 0 : currentMail._account) || ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id); }, [currentMail === null || currentMail === void 0 ? void 0 : currentMail._account]);
    const isMailAccount = useMemo(() => isMainAccount(account), [account]);
    const asideContactProp = useMemo(() => {
        var _a, _b, _c;
        const sender = currentMail === null || currentMail === void 0 ? void 0 : currentMail.sender;
        let asideContactProp;
        if (sender === null || sender === void 0 ? void 0 : sender.contact) {
            asideContactProp = transContactModel2ContactItem(sender.contact);
        }
        if (((_c = (_b = (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.prop) === null || _b === void 0 ? void 0 : _b.accountAlias) === null || _c === void 0 ? void 0 : _c.includes(email)) || accountApi.getIsSameSubAccountSync(email, account)) {
            const receiversContact = [];
            ((currentMail === null || currentMail === void 0 ? void 0 : currentMail.receiver) || []).forEach(item => {
                if (item === null || item === void 0 ? void 0 : item.contact) {
                    receiversContact.push(transContactModel2ContactItem(item.contact));
                }
            });
            if (receiversContact.length === 1) {
                asideContactProp = receiversContact[0];
            }
            else if (receiversContact.length > 1) {
                const customer = receiversContact.find(item => item.customerRole === 'myCustomer');
                const enterpriseCustomer = receiversContact.find(item => item.customerRole === 'colleagueCustomer');
                const openSeaCustomer = receiversContact.find(item => item.customerRole === 'openSeaCustomer');
                const external = receiversContact.find(item => item.type === 'external');
                const personal = receiversContact.find(item => item.type === 'personal');
                const enterprise = receiversContact.find(item => item.type === 'enterprise');
                asideContactProp = customer || enterpriseCustomer || openSeaCustomer || external || personal || enterprise;
            }
        }
        return asideContactProp;
    }, [currentMail]);
    const asideContactModel = useContactModel({ email: asideContactProp === null || asideContactProp === void 0 ? void 0 : asideContactProp.email, name: asideContactProp === null || asideContactProp === void 0 ? void 0 : asideContactProp.name, _account: asideContactProp === null || asideContactProp === void 0 ? void 0 : asideContactProp._account });
    const MailMultOperPanelMemo = useMemo(() => {
        if (isCustomerTab) {
            return React.createElement(CustomerMailMultOperPanel, null);
        }
        if (isSdTab) {
            return React.createElement(SubordinateMailMultOperPanel, null);
        }
        return React.createElement(MailMultOperPanel, null);
    }, [isCustomerTab]);
    const isLeftRight = useMemo(() => configMailLayout === '1', [configMailLayout]);
    const featureConfig = useMemo(() => {
        return {
            mailDiscuss: isMailAccount,
            relatedMail: isMailAccount,
            attachCard: (tempContent === null || tempContent === void 0 ? void 0 : tempContent.isTpMail) ? tpMailAttConfig : undefined,
        };
    }, [isMailAccount, tempContent === null || tempContent === void 0 ? void 0 : tempContent.isTpMail]);
    const idAccountKey = useMemo(() => {
        return id + (currentMail === null || currentMail === void 0 ? void 0 : currentMail._account) + '';
    }, [id, currentMail]);
    const readMailVisible = useMemo(() => {
        return !!([tabType.read].includes(currentTabType) || ((isLeftRight || isUpDown) && [tabType.readMain].includes(currentTabType))) && !!id;
    }, [currentTabType, isLeftRight, isUpDown, idAccountKey]);
    const readMailCom = useMemo(() => {
        var _a;
        return (React.createElement(BaseReadMail, { sliceId: sliceIdCm, mailId: {
                id,
                account: (currentMail === null || currentMail === void 0 ? void 0 : currentMail._account) || accountId || '',
            }, from: from, openInNewWindow: openInNewWindow, tempContent: tempContent, getSignMailContent: getSignMailContent, isUpDown: isUpDown, featureConfig: featureConfig, readOnly: readOnly, requestUniqWrap: requestUniqWrap, contactType: (_a = asideContactModel === null || asideContactModel === void 0 ? void 0 : asideContactModel.contact) === null || _a === void 0 ? void 0 : _a.type, emptyRender: emptyRender, visible: readMailVisible, hotKey: true }));
    }, [idAccountKey, from, openInNewWindow, getSignMailContent, isMailAccount, featureConfig, readOnly, requestUniqWrap, emptyRender, readMailVisible]);
    return logicListModel == LIST_MODEL.MULTIPLE && isLeftRight ? MailMultOperPanelMemo : readMailCom;
};
export default MainReadMail;
